import { FiltroConcentracaoColheita } from "core/features/maps/typings";
import { AxiosResponse } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { TalhaoResult } from "../typings";
import { mapPropertiesFeature } from "../utils/mapper";
import { useConcentracaoColheitaStore } from "core/features/filters/store/useConcentracaoColheitaStore";
import useAdvancedFiltersConcentracaoColheita from "components/maps/base-map/components/advancedFilters/items/hooks/useAdvancedFiltersConcentracaoColheita";
import { useFilters } from "core/features/filters/store";
import { useMapStore } from "../store/useMapStore";
import URL from "core/resources/urls";

let controller: AbortController | null = null;

export function useMapaConcentracaoColheita() {
  const {
    filters: { unidade, safra, tipoMapa, setor },
  } = useFilters();
  const { update: updateMapStore } = useMapStore();

  const { filters } = useConcentracaoColheitaStore();
  const { concentracoes, ocupacao, tecnologias, tipo } = filters;
  const { items: { filterSafraPeriodos } } = useAdvancedFiltersConcentracaoColheita();

  const unidadeId = unidade?.id;
  const safraId = safra?.id;

  const url = `${URL.MAPAS.MAPA_CONCENTRACAO_COLHEITA(unidadeId!, safraId!)}`;
  const queryKey = url;

  return useQuery(
    [queryKey, setor, tipoMapa, concentracoes, ocupacao, tipo, tecnologias, filterSafraPeriodos],
    async (): Promise<TalhaoResult> => {
      const headers = {
        "api-version": "1",
      };

      if (controller) {
        controller.abort();
        controller = null;
      }

      controller = new AbortController();

      const response = await http.post<
        FiltroConcentracaoColheita,
        AxiosResponse<TalhaoResult>
      >(
        url,
        {
          setorId: setor?.id,
          tipo,
          concentracoes,
          ocupacao,
          tecnologias: tecnologias.filter((item) => item),
          safraPeriodos: filterSafraPeriodos,
        },
        {
          headers,
          signal: controller.signal,
        }
      );

      response?.data?.features.forEach(mapPropertiesFeature);

      updateMapStore(response?.data);

      return response?.data;
    },
    {
      enabled: !!(ocupacao && tipo && tecnologias.length > 0),
    }
  );
}
